import { IChapter } from '@interfaces/pose.interface';

export const MIN_DURATION_SEC = 3;
export const MIN_GAP_SEC = 2;
export const DEFAULT_DURATION = 10;

export const prevChapterData = (chapterData: IChapter[], currentTime: number) => {
  return chapterData.filter(({ endTime }) => endTime < currentTime).pop();
};

export const currentChapterData = (chapterData: IChapter[], nowTime: number) => {
  return chapterData.filter(({ startTime, endTime }) => startTime <= nowTime && nowTime <= endTime);
};

export const nextChapterData = (chapterData: IChapter[], currentTime: number) => {
  return chapterData.filter(({ startTime }) => currentTime < startTime)[0];
};

export const calcBeginBoundTimeLimit = (chapterData: IChapter[], chapter: IChapter) => {
  if (chapter.chapterIdx === 0) return 0;
  const prevChapter = prevChapterData(chapterData, chapter.startTime);
  return prevChapter ? prevChapter.endTime + MIN_GAP_SEC : 0;
};

export const calcEndBoundTimeLimit = (chapterData: IChapter[], chapter: IChapter) => {
  if (chapter.chapterIdx + 1 === chapterData.length) return;
  const nextChapter = nextChapterData(chapterData, chapter.endTime);
  return nextChapter ? nextChapter.startTime - MIN_GAP_SEC : undefined;
};
